import { tableStyle } from "../style";

export const colouredTableStyle = { ...tableStyle };
